import {
  makeApiActionCreator,
} from './utils';
import * as api from '../api/auth0';

export const AUTH0_ORGANIZATION_ID_FETCH_START = 'AUTH0/AUTH0_ORGANIZATION_ID_FETCH_START';
export const AUTH0_ORGANIZATION_ID_FETCH_SUCCESS = 'AUTH0/AUTH0_ORGANIZATION_ID_FETCH_SUCCESS';
export const AUTH0_ORGANIZATION_ID_FETCH_ERROR = 'AUTH0/AUTH0_ORGANIZATION_ID_FETCH_ERROR';

export const fetchAuth0OrganizationId = makeApiActionCreator(
  api.fetchAuth0OrganizationId,
  AUTH0_ORGANIZATION_ID_FETCH_START,
  AUTH0_ORGANIZATION_ID_FETCH_SUCCESS,
  AUTH0_ORGANIZATION_ID_FETCH_ERROR
);
